export default __webpack_public_path__ + "static/media/delete.87f0218b.svg";